angular.module('dealerware.web.data').factory('DealerwareWebhookCollection', function (
    Collection, DealerwareWebhookFactory, WebhookModel) {

    'use strict';
    var collection = new Collection({

        baseEndpoint: '/locations/:location_id/webhooks',

        params                          : undefined,
        responseFormatter               : undefined,
        ignoreDefaultAssociationMapper  : true,
        rootNode                        : 'webhooks',
        rootNodeResponse                : undefined,
        rootNodeRequest                 : undefined,
        requestTransforms               : undefined,

        model: function(modelData) {

            // Eh, not a very elegant way of smooshing the Webhook model together into
            // the Model/Collection.
            //
            var webhookModel    = new WebhookModel(modelData);
            var webhookInstance = DealerwareWebhookFactory.getInstance().initialize(modelData);

            webhookInstance.data        = webhookModel.data;
            webhookInstance.master      = webhookModel.master;
            webhookInstance.errors      = webhookModel.errors;
            webhookInstance.lookupValue = webhookModel.lookupValue;

            return webhookInstance;
        },

        customActions: {
            index: {
                method: 'GET',
                endpoint: '/locations/:location_id/webhooks',
                ignoreDefaultRootNodeRequest: true,
                ignoreDefaultAssociationMapper: true
            }
        },

        responseTransforms: {
            index : function(args, data) {

                data.forEach( function (webhookModelInstance, i) {
                    Object.keys(data[i].data).forEach( function(key) {
                        data[i].data[key] = data[i][key];
                        if (data[i][key + 'Display'] !== undefined) {
                            data[i].data[key] = data[i][key + 'Display'];
                        }
                    });
                    data[i].index = i;
                });
            }
        }
    });

    jQuery.extend(collection.prototype,{});

    return collection;
});
